<template>
  <section class="relative mx-auto w-full">
    <slot />
  </section>
</template>
